import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { setPreviewLoading } from "../../redux/actions";
import { preloadImage, animate } from "../../helpers/common";

import styles from "./index.module.scss";

class PreviewImage extends Component {
  state = {
    top: undefined,
    frame: undefined,
    shadow: undefined,
    prevTop: undefined,
    prevFrame: undefined,
    prevShadow: undefined,
    needUpdateTop: false,
    needUpdateFrame: false,
    needUpdateShadow: false,
  };

  constructor(props, context) {
    super(props, context);

    this.topImg = React.createRef();
    this.prevTopImg = React.createRef();
    this.frameImg = React.createRef();
    this.prevFrameImg = React.createRef();
    this.shadowImg = React.createRef();
    this.prevShadowImg = React.createRef();
  }

  componentDidMount() {
    const { images } = this.props;

    if (images) {
      this.setState({
        top: images.top,
        frame: images.frame,
        shadow: images.shadow,
      });
    }
  }

  async componentWillReceiveProps(nextProps, nextContext) {
    const { images: prevImages, params: prevParams } = this.props,
      { images, params } = nextProps;

    if (images) {
      this.props.enablePreviewLoading();

      try {
        if (images.top) await preloadImage(images.top);
        if (images.frame) await preloadImage(images.frame);
        if (images.shadow) await preloadImage(images.shadow);
      } catch (e) {}

      this.props.disablePreviewLoading();

      const top = images.top,
        frame = images.frame,
        shadow = images.shadow,
        prevTop = prevImages ? prevImages.top : undefined,
        prevFrame = prevImages ? prevImages.frame : undefined,
        prevShadow = prevImages ? prevImages.shadow : undefined;

      let needUpdateTop,
        needUpdateFrame,
        needUpdateShadow = false;

      if (top !== prevTop || params.sizes.value !== prevParams.sizes.value) {
        needUpdateTop = true;
      }

      if (frame !== prevFrame) {
        needUpdateFrame = true;
      }

      if (shadow !== prevShadow) {
        needUpdateShadow = true;
      }

      this.setState(
        {
          top,
          frame,
          shadow,
          prevTop,
          prevFrame,
          prevShadow,
          needUpdateTop,
          needUpdateFrame,
          needUpdateShadow,
        },
        () => {
          this.animateImagesChange();
        }
      );
    }
  }

  animateImagesChange = () => {
    const {
      prevTop,
      prevFrame,
      prevShadow,
      needUpdateTop,
      needUpdateFrame,
      needUpdateShadow,
    } = this.state;

    if (prevTop && needUpdateTop) {
      const move = 20;

      this.topImg.current.style.transform = `translateX(-${move}%)`;
      this.topImg.current.style.opacity = 0;

      this.prevTopImg.current.style.opacity = 1;

      animate({
        draw: (progress) => {
          this.prevTopImg.current.style.opacity = Math.sin(Math.acos(progress));
          this.prevTopImg.current.style.transform = `translateX(${
            progress * move
          }%)`;
        },
        duration: 280,
      });

      setTimeout(() => {
        animate({
          draw: (progress) => {
            this.topImg.current.style.opacity = progress;
            this.topImg.current.style.transform = `translateX(-${
              move - progress * move
            }%)`;
          },
          duration: 280,
        });
      }, 100);
    }

    if (prevFrame && needUpdateFrame) {
      this.frameImg.current.style.opacity = 0;

      animate({
        draw: (progress) => {
          this.prevFrameImg.current.style.opacity = 1 - progress;
        },
        duration: 280,
      });

      setTimeout(() => {
        animate({
          draw: (progress) => {
            this.frameImg.current.style.opacity = progress;
          },
          duration: 280,
        });
      }, 100);
    }

    if (prevShadow && needUpdateShadow) {
      this.shadowImg.current.style.opacity = 0;

      animate({
        draw: (progress) => {
          this.prevShadowImg.current.style.opacity = 1 - progress;
        },
        duration: 280,
      });

      setTimeout(() => {
        animate({
          draw: (progress) => {
            this.shadowImg.current.style.opacity = progress;
          },
          duration: 280,
        });
      }, 100);
    }
  };

  render() {
    const { className, images } = this.props;

    if (!images) {
      return null;
    }

    const { top, frame, shadow, prevTop, prevFrame, prevShadow } = this.state;

    return (
      <div className={classNames(styles["preview"], className)}>
        <img src={top} className={styles["preview__top"]} ref={this.topImg} />
        {prevTop && (
          <img
            src={prevTop}
            className={styles["preview__top"]}
            ref={this.prevTopImg}
          />
        )}
        <img
          src={frame}
          className={styles["preview__frame"]}
          ref={this.frameImg}
        />
        {prevFrame && (
          <img
            src={prevFrame}
            className={`${styles["preview__frame"]}`}
            ref={this.prevFrameImg}
          />
        )}
        <img
          src={shadow}
          className={styles["preview__shadow"]}
          ref={this.shadowImg}
        />
        {prevShadow && (
          <img
            src={prevShadow}
            className={`${styles["preview__shadow"]}`}
            ref={this.prevShadowImg}
          />
        )}
        <img
          src={images.background}
          className={styles["preview__background"]}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    images: state.previewImage,
    params: state.params,
  }),
  (dispatch) => ({
    enablePreviewLoading: () => dispatch(setPreviewLoading(true)),
    disablePreviewLoading: () => dispatch(setPreviewLoading(false)),
  })
)(PreviewImage);
